import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollOptions = { top: 0, left: 0, behavior: "smooth" };
    const target = document.body || window;
    target.scrollTo(scrollOptions);
  }, [pathname]);

  return null;
}
